import { render } from "./ProcessoAssuntoComponent.vue?vue&type=template&id=400869f4&scoped=true"
import script from "./ProcessoAssuntoComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoAssuntoComponent.vue?vue&type=script&lang=js"

import "./ProcessoAssuntoComponent.vue?vue&type=style&index=0&id=400869f4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400869f4"]])

export default __exports__